import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import Grid from "../charts/nine-box-grid/Grid"
import NineBoxGridSummaryShape from "../../state/shapes/NineBoxGridSummaryShape"
import NineBoxGridDrillDownBoxShape from "../../state/shapes/NineBoxGridDrilldownBoxShape"

function NineBoxGridSmall({
  exportEndpoint,
  appliedFilters,
  summaryData,
  drilldownData,
  dashboard,
  subtitleKey
}) {
  const identifier="small-nine-box-grid"
  const titleKey="Widgets.NineBoxGrid.Title"
  return (
    <Widget
      id={identifier}
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.NineBoxGrid.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
    >
      <Grid isSmall9BG summary={summaryData} drilldown={drilldownData} dashboard={dashboard} widgetIdentifier={identifier} titleKey={titleKey}/>
    </Widget>
  )
}

NineBoxGridSmall.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  summaryData: PropTypes.arrayOf(PropTypes.shape(NineBoxGridSummaryShape)).isRequired,
  drilldownData: PropTypes.shape(NineBoxGridDrillDownBoxShape),
  exportEndpoint: PropTypes.string.isRequired,
  dashboard: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string
}

NineBoxGridSmall.defaultProps = {
  drilldownData: null
}

export default NineBoxGridSmall



// WEBPACK FOOTER //
// ./src/components/widgets/NineBoxGridSmall.jsx